<template>
  <modal :center="false" :show="visible" modalClasses="modal-lg">
    <h3 class="text-center">
      Lệnh chế tạo đã lập
    </h3>
    <block ref="bmdal">
      <base-table :data="manufactures" class="soft-table">
        <template slot="columns">
          <th>STT</th>
          <th>Mã lệnh</th>
          <th>Ngày tạo</th>
          <th>Ngày giao hàng</th>
          <th>Số lượng cần dệt</th>
          <th>Số lượng đã dệt</th>
        </template>

        <template slot-scope="{ row, index }">
          <tr :key="index">
            <td class="bg-info text-light col-fix text-center">
              {{ index + 1 }}
            </td>
            <td>{{ row.code }}</td>
            <td>{{ $dateUnix(row.dateCreated) }}</td>
            <td>{{ $date(row.dateDelivery) }}</td>
            <td class="text-right">
              {{ $formatNumber(row.quantityInventory) }}
            </td>
            <td class="text-right">{{ $formatNumber(row.quantityProduce) }}</td>
          </tr>
        </template>
      </base-table>

      <b-row>
        <b-col sm="12" md="4">
          <b-button class="mb-2" block variant="secondary" @click="handleClose">
            Đóng (Esc)
          </b-button>
        </b-col>
      </b-row>
    </block>
    <event
      @doCancel="handleClose"
      @doSave="doSave(0)"
      @doSaveContinue="doSave(1)"
    ></event>
  </modal>
</template>
<script>
export default {
  props: {},
  data() {
    return {
      visible: false,
      manufactures: [],
      fields: [
        {
          variant: "primary",
          key: "id",
          class: "col-fix checkbox"
        },
        {
          key: "code",
          label: "Mã lệnh chế tạo",
          sortable: true,
          class: "col-fix"
        },
        {
          key: "color",
          label: "Thông tin màu sắc",
          sortable: true,
          class: "col-fix"
        },
        {
          key: "quantityOrder",
          label: "Số lượng",
          sortable: true,
          class: "text-center"
        },
        {
          key: "dateDelivery",
          label: "Ngày giao hàng",
          sortable: true,
          class: "text-center"
        }
      ]
    };
  },
  methods: {
    setData(manufactures) {
      this.manufactures = manufactures;
    },
    handleClose() {
      this.visible = false;
    }
  }
};
</script>
<style lang="scss"></style>
